import axios from "../API/axios";
import { getLangKey } from "../utils/language";

const sessionId = () => localStorage.getItem("sessionId") || "";

/** Fire-and-forget impression batch (never throws to caller UX). */
export async function recordImpressions(items) {
  try {
    if (!Array.isArray(items) || items.length === 0) return;
    await axios.post("/Impression/Batch", {
      DeviceType: "Web",
      sessionId: sessionId(),
      LangKey: getLangKey(),
      Items: items.map((i) => ({
        TargetType: i.targetType,
        TargetId: String(i.targetId),
        Source: i.source ?? 1,
      })),
    });
  } catch {
    /* analytics must not break UX */
  }
}

export async function fetchPollByPost(postId) {
  const res = await axios.get(
    `/Poll/GetByPost?DeviceType=Web&PostId=${postId}&LangKey=${encodeURIComponent(getLangKey())}`,
  );
  return res?.data?.responseData ?? res?.data?.ResponseData ?? null;
}

export async function createPollForPost(postId, { options, isMultipleChoice = false, description = "" }) {
  const res = await axios.post("/Poll/CreateWithPost", {
    DeviceType: "Web",
    sessionId: sessionId(),
    LangKey: getLangKey(),
    PostId: postId,
    Description: description,
    IsMultipleChoice: isMultipleChoice,
    IsAnonymous: true,
    IsCommentsEnabled: true,
    Options: options,
  });
  return res?.data?.responseData ?? res?.data?.ResponseData ?? null;
}

export async function votePoll(pollId, optionIds) {
  const res = await axios.post("/Poll/Vote", {
    DeviceType: "Web",
    sessionId: sessionId(),
    LangKey: getLangKey(),
    PollId: pollId,
    OptionIds: optionIds,
  });
  return res?.data?.responseData ?? res?.data?.ResponseData ?? null;
}

export async function fetchImpressionSummary(targetType, targetId) {
  const res = await axios.get(
    `/Impression/Summary?DeviceType=Web&TargetType=${targetType}&TargetId=${encodeURIComponent(targetId)}&LangKey=${encodeURIComponent(getLangKey())}`,
  );
  return res?.data?.responseData ?? res?.data?.ResponseData ?? null;
}
